module.exports = __webpack_public_path__ + "img/vista-2.07936956.svg";